
/* 
    NOTE: 
    There is an assumption that the below keys/codes for fields and tags will be consistent and configured correctly;
    if these change then: 1) The below references will be wrong, and 2) it might actually break the whole thing due to JS errors.
    
    The correct values must be enforced or, if that cannot be done, the configuration of the values in 
    the apps needs to be changed so that it can all be consistent and the data reliable.
*/
// Tag Keys
const MODEL_KEY = 'model';
const BADGE_KEY = 'fit_multiselect'
const PRESCRIPTIBLE_KEY = 'prescriptible';
const ONLINE_ONLY_KEY = 'online only'
const BLUE_LIGHT = 'badge|blue light'
// Field codes
const LEFT_SPH_FIELD_CODE = 'left_eye_sph';
const RIGHT_SPH_FIELD_CODE = 'right_eye_sph';
const UPLOAD_PRESCRIPTION_FIELD_CODE = 'upload_prescription'
const EMAIL_PRESCRIPTION_FIELD_CODE = 'email_prescription'
const ENTER_PRESCRIPTION_FIELD_CODE = 'enter_prescription'
const LENS_THICKNESS_STEP_CATEGORY = 'lens_thickness';
// Lens thickness codes, in case they add in more
const LENS_THICKNESS_CODE_15 = '_15';
const LENS_THICKNESS_CODE_156 = '_156';
const LENS_THICKNESS_CODE_16 = '_16';
const LENS_THICKNESS_CODE_167 = '_167';
const LENS_THICKNESS_CODE_171 = '_171';
const LENS_THICKNESS_CODE_174 = '_174';

export default {
    MODEL_KEY: MODEL_KEY,
    BADGE_KEY: BADGE_KEY,
    PRESCRIPTIBLE_KEY: PRESCRIPTIBLE_KEY,
    ONLINE_ONLY_KEY: ONLINE_ONLY_KEY,
    BLUE_LIGHT: BLUE_LIGHT,
    LEFT_SPH_FIELD_CODE: LEFT_SPH_FIELD_CODE,
    RIGHT_SPH_FIELD_CODE: RIGHT_SPH_FIELD_CODE,
    UPLOAD_PRESCRIPTION_FIELD_CODE: UPLOAD_PRESCRIPTION_FIELD_CODE,
    EMAIL_PRESCRIPTION_FIELD_CODE: EMAIL_PRESCRIPTION_FIELD_CODE,
    ENTER_PRESCRIPTION_FIELD_CODE: ENTER_PRESCRIPTION_FIELD_CODE,
    LENS_THICKNESS_STEP_CATEGORY: LENS_THICKNESS_STEP_CATEGORY,
    LENS_THICKNESS_CODE_15: LENS_THICKNESS_CODE_15,
    LENS_THICKNESS_CODE_156: LENS_THICKNESS_CODE_156,
    LENS_THICKNESS_CODE_16: LENS_THICKNESS_CODE_16,
    LENS_THICKNESS_CODE_167: LENS_THICKNESS_CODE_167,
    LENS_THICKNESS_CODE_171: LENS_THICKNESS_CODE_171,
    LENS_THICKNESS_CODE_174: LENS_THICKNESS_CODE_174,
  }